import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoggingService } from '@pit/core';

@NgModule({
    imports: [
        CommonModule
    ]
})
export class PinItCoreSignalRModule {

    constructor(logger: LoggingService) {
        logger.debug('PinSignalRModule --> constructor()');
    }

    public static forRoot(): ModuleWithProviders<PinItCoreSignalRModule> {
        return {
            ngModule: PinItCoreSignalRModule,
            providers: []
        };
    }

}
